import { useLoading } from "../context/LoadingContext";

import React, { useState, useEffect, useContext } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import "../css/RelatorioRotina.css";
import {
  FaArrowLeft,
  FaSearch,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { registerLocale } from "react-datepicker";
import ptBR from "date-fns/locale/pt-BR";
import SelectBoxResponsavelPesquisa from "./SelectBoxResponsavelPesquisa";
import BackButton from "../components/BackButton";
import { useRestaurante } from "../context/RestauranteContext";
import { useUser } from "../context/UserContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from "recharts";

const COLORS = [
  "#0088FE",
  "#00C49F",
  "#FFBB28",
  "#FF8042",
  "#8884d8",
  "#82ca9d",
];

registerLocale("pt-BR", ptBR);

const RelatorioRotina = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { restauranteId } = useRestaurante();
  const { user } = useUser();
  const { setIsLoading } = useLoading();

  const today = new Date();
  const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);

  const [dataInicio, setDataInicio] = useState(firstDayOfMonth);
  const [dataFim, setDataFim] = useState(lastDayOfMonth);
  const [responsavelSelecionado, setResponsavelSelecionado] = useState("");
  const [tipoRotina, setTipoRotina] = useState("");
  const [reportData, setReportData] = useState(null);
  const [isLoadingLocal, setIsLoadingLocal] = useState(false);
  const [expandedSections, setExpandedSections] = useState({
    resumo: true,
    graficos: true,
    detalhes: true,
  });

  const toggleSection = (section) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const handleSearch = async () => {
    const toastId = toast.loading("Buscando relatório...");
    setIsLoading(true);
    setIsLoadingLocal(true);

    const inicio = dataInicio || firstDayOfMonth;
    const fim = dataFim || lastDayOfMonth;

    const formattedDataInicio = inicio.toISOString().split("T")[0];
    const formattedDataFim = fim.toISOString().split("T")[0];

    let apiUrl = `${process.env.REACT_APP_BASE_URL}/api/v1/relatorios/rotinas?idRestaurante=${restauranteId || id}`;
    apiUrl += `&dataInicio=${formattedDataInicio}`;
    apiUrl += `&dataFim=${formattedDataFim}`;

    if (tipoRotina) {
      apiUrl += `&tipo=${tipoRotina}`;
    }
    if (responsavelSelecionado) {
      apiUrl += `&idResponsavel=${responsavelSelecionado}`;
    }

    try {
      const token = user?.access_token;
      if (!token) {
        console.error("Token de autenticação não encontrado.");
        toast.update(toastId, {
          render: "Token de autenticação não encontrado.",
          type: "error",
          isLoading: false,
          autoClose: 3000,
        });
        return;
      }

      const response = await fetch(apiUrl, {
        headers: {
          Authentication: token,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      setReportData(data);
      toast.update(toastId, {
        render: "Relatório carregado com sucesso!",
        type: "success",
        isLoading: false,
        autoClose: 2000,
      });
    } catch (error) {
      console.error("Erro ao buscar relatório:", error);
      toast.update(toastId, {
        render: "Erro ao buscar relatório.",
        type: "error",
        isLoading: false,
        autoClose: 3000,
      });
    } finally {
      setIsLoading(false);
      setIsLoadingLocal(false);
    }
  };

  useEffect(() => {
    handleSearch();
  }, [restauranteId, id, user]);

  const prepareTipoData = () => {
    if (!reportData?.resumo?.tiposDisponiveis) return [];

    return reportData.resumo.tiposDisponiveis.map((tipo) => ({
      name: tipo,
      value: reportData.detalhes.filter((item) => item.tipo === tipo).length,
    }));
  };

  const prepareStatusData = () => {
    if (!reportData?.detalhes) return [];

    const totalFinalizadas = reportData.detalhes.reduce((acc, item) => {
      return acc + (item.atividades.some((a) => a.finalizada) ? 1 : 0);
    }, 0);

    return [
      { name: "Concluídas", value: totalFinalizadas },
      {
        name: "Pendentes",
        value: reportData.detalhes.length - totalFinalizadas,
      },
    ];
  };

  return (
    <div className="relatorio-rotina-container">
      <ToastContainer />
      <BackButton inline />
      <h2>Relatório de Rotinas</h2>

      <div className="filtro-container-rotina">
        <div className="filtro-group">
          <label>Data Início:</label>
          <DatePicker
            selected={dataInicio}
            onChange={(date) => setDataInicio(date)}
            dateFormat="dd/MM/yyyy"
            locale="pt-BR"
            placeholderText="Selecione a data de início"
            className="date-picker"
          />
        </div>
        <div className="filtro-group">
          <label>Data Fim:</label>
          <DatePicker
            selected={dataFim}
            onChange={(date) => setDataFim(date)}
            dateFormat="dd/MM/yyyy"
            locale="pt-BR"
            placeholderText="Selecione a data de fim"
            className="date-picker"
          />
        </div>
        <div className="filtro-group">
          <label>Tipo de Rotina:</label>
          <input
            type="text"
            value={tipoRotina}
            onChange={(e) => setTipoRotina(e.target.value)}
            placeholder="Filtre por tipo"
            className="text-input"
          />
        </div>
        <div className="filtro-group">
          <label>Responsável:</label>
          <SelectBoxResponsavelPesquisa
            value={responsavelSelecionado}
            onChange={setResponsavelSelecionado}
            className="select-box"
          />
        </div>
        <button
          onClick={handleSearch}
          className={isLoadingLocal ? "search-button loading" : "search-button"}
          disabled={isLoadingLocal}
        >
          <FaSearch /> {isLoadingLocal ? "Buscando..." : "Buscar"}
        </button>
      </div>

      {(
        reportData ? (
          <div className="relatorio-content">
            {/* Seção de Resumo */}
            <div className="section-container">
              <div
                className="section-header"
                onClick={() => toggleSection("resumo")}
              >
                <h3>Resumo Geral</h3>
                {expandedSections.resumo ? <FaChevronUp /> : <FaChevronDown />}
              </div>
              {expandedSections.resumo && (
                <div className="metrics-grid">
                  <div className="metric-card">
                    <span className="metric-value">
                      {reportData.resumo.totalAtividades}
                    </span>
                    <span className="metric-label">Total de Atividades</span>
                  </div>
                  <div className="metric-card">
                    <span className="metric-value">
                      {reportData.resumo.totalAtividadesFinalizadas}
                    </span>
                    <span className="metric-label">Atividades Finalizadas</span>
                  </div>
                  <div className="metric-card">
                    <span className="metric-value">
                      {parseFloat(
                        reportData.resumo.percentualConclusao
                      ).toFixed(2)}
                      %
                    </span>
                    <span className="metric-label">
                      Percentual de Conclusão
                    </span>
                  </div>
                </div>
              )}
            </div>

            {/* Seção de Gráficos */}
            <div className="section-container">
              <div
                className="section-header"
                onClick={() => toggleSection("graficos")}
              >
                <h3>Análise Gráfica</h3>
                {expandedSections.graficos ? (
                  <FaChevronUp />
                ) : (
                  <FaChevronDown />
                )}
              </div>
              {expandedSections.graficos && (
                <div className="charts-container">
                  <div className="chart-wrapper">
                    <h4>Distribuição por Tipo</h4>
                    <ResponsiveContainer width="100%" height={300}>
                      <PieChart>
                        <Pie
                          data={prepareTipoData()}
                          cx="50%"
                          cy="50%"
                          labelLine={false}
                          outerRadius={80}
                          fill="#8884d8"
                          dataKey="value"
                          nameKey="name"
                          label={({ name, percent }) =>
                            `${name}: ${(percent * 100).toFixed(0)}%`
                          }
                        >
                          {prepareTipoData().map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>

                  <div className="chart-wrapper">
                    <h4>Status das Atividades</h4>
                    <ResponsiveContainer width="100%" height={300}>
                      <PieChart>
                        <Pie
                          data={prepareStatusData()}
                          cx="50%"
                          cy="50%"
                          labelLine={false}
                          outerRadius={80}
                          fill="#8884d8"
                          dataKey="value"
                          nameKey="name"
                          label={({ name, percent }) =>
                            `${name}: ${(percent * 100).toFixed(0)}%`
                          }
                        >
                          {prepareStatusData().map((entry, index) => (
                            <Cell
                              key={`cell-${index}`}
                              fill={COLORS[index % COLORS.length]}
                            />
                          ))}
                        </Pie>
                        <Tooltip />
                        <Legend />
                      </PieChart>
                    </ResponsiveContainer>
                  </div>
                </div>
              )}
            </div>
            <div className="section-container detalhes-section">
              <div
                className="section-header"
                onClick={() => toggleSection("detalhes")}
              >
                <h3>Detalhes das Rotinas</h3>
                {expandedSections.detalhes ? (
                  <FaChevronUp />
                ) : (
                  <FaChevronDown />
                )}
              </div>
              {expandedSections.detalhes && (
                <div className="table-container">
                  <table className="rotinas-table">
                    <thead>
                      <tr>
                        <th>Descrição</th>
                        <th>Data</th>
                        <th>Tipo</th>
                        <th>Responsável</th>
                        <th>Atividades</th>
                        <th>Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reportData.detalhes.map((rotina, index) => (
                        <tr key={index}>
                          <td>{rotina.descricaoRotina}</td>
                          <td>
                            {new Date(rotina.data).toLocaleDateString("pt-BR")}
                          </td>
                          <td>{rotina.tipo}</td>
                          <td>{rotina.responsavel}</td>
                          <td>
                            <ul className="atividades-list">
                              {rotina.atividades.map((atividade, idx) => (
                                <li
                                  key={idx}
                                  className={
                                    atividade.finalizada
                                      ? "finalizada"
                                      : "pendente"
                                  }
                                >
                                  {atividade.nome}{" "}
                                  {atividade.finalizada ? "✓" : "✗"}
                                </li>
                              ))}
                            </ul>
                          </td>
                          <td>
                            <span
                              className={`status-badge ${
                                rotina.atividades.some((a) => a.finalizada)
                                  ? rotina.atividades.every((a) => a.finalizada)
                                    ? "completa"
                                    : "parcial"
                                  : "pendente"
                              }`}
                            >
                              {rotina.atividades.some((a) => a.finalizada)
                                ? rotina.atividades.every((a) => a.finalizada)
                                  ? "Completa"
                                  : "Parcial"
                                : "Pendente"}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        ) : (
          <p className="no-data-message">
            Nenhum dado de rotina encontrado para os filtros selecionados.
          </p>
        ))}
      </div>
  );
};

export default RelatorioRotina;
